import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { closeModalById } from '../store/actions/modal-actions';
import store from '../store/store';

import Button from '../components/Button';

const mapStateToProps = ({ systemModals }) => ({
  modalStack: systemModals.modalStack,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModalById,
    },
    dispatch
  );

const SystemModals = props =>
  props.modalStack.map(modal => {
    const close = () => props.closeModalById(modal.modalId);
    return (
      <Modal
        key={modal.modalId}
        isOpen={modal.isOpen}
        toggle={close}
        onExit={
          modal.exitAction !== undefined
            ? () => store.dispatch(modal.exitAction)
            : undefined
        }
        centered
        className={modal.className}
        backdropClassName="CriteriaModal_background"
      >
        {modal.title && <ModalHeader toggle={close}>{modal.title}</ModalHeader>}
        {modal.message && <ModalBody>{modal.message}</ModalBody>}
        <ModalFooter>
          <Button onClick={close} label="Close" />
        </ModalFooter>
      </Modal>
    );
  });

SystemModals.propTypes = {
  modalStack: PropTypes.arrayOf(PropTypes.object),
  closeModalById: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SystemModals);
